import React from 'react';
import * as Yup from 'yup';

import { ApplicationFlow } from '../components';
import { documentTypes } from '../data';


const Description = () => (
  <React.Fragment>
    <p>A sole proprietorship is a unincorporated business owned by one individual, making it the simplest form of business to start and operate. There are over 20 million sole proprietorships operating in the United States and Canada, making it by far the most popular form of business ownership.</p>
    <p>In a sole proprietorship, there is no difference between the individual and business for tax purposes.</p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Application Information',
    fields: new Map([
      ['firstName'],
      ['middleName'],
      ['lastName'],
      ['socialSecurity'],
      ['verifySocialSecurity'],
      ['title'],
      ['dba'],
      ['suffix', {
        initial: 'MD',
      }],
    ]),
  },
  {
    legend: 'Business Information',
    fields: new Map([
      ['businessAddress'],
      ['businessCity'],
      ['businessState'],
      ['businessZip'],
      ['businessCounty'],
      ['mailingAddressDiff'],
    ]),
  },
  {
    legend: 'Business Questions',
    fields: new Map([
      ['businessApplyReason'],
      ['businessActivity'],
      ['businessServices'],
      ['commonQuestionOne'],
      ['commonQuestionTwo'],
      ['commonQuestionThree'],
      ['commonQuestionFour'],
      ['businessAppliedBefore'],
      ['businessHireEmployees'],
    ]),
  },
  {
    legend: 'Business Dates',
    fields: new Map([
      ['businessDateStart'],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail'],
      ['customerContactEmailVerify'],
    ]),
  },
];


const SoleProprietorApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Sole Proprietor Application"
    documentType={documentTypes.SOLE_PROPRIETOR}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default SoleProprietorApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/sole-proprietor-application.js